"use client";

import React, { useState, useEffect, useContext } from "react";
import client from "@/lib/api/client";
import { useLayout } from "@/lib/context/layout";

export const ThemeElement = () => {
    const { activeContext, refreshDashboards } = useLayout();
    const [css, setCss] = useState("");
    const [icon, setIcon] = useState("");

    const update = () => {
        const [provider, reseller, client_id] = client.get_context(activeContext);
        client.get_theme(reseller, client_id).then((theme: { css: string; icon: string }) => {
            setCss(theme.css);
            setIcon(theme.icon);
        });
    };

    useEffect(() => {
        update();
    }, [activeContext, refreshDashboards]);

    return (
        <>
            {icon && <link rel="icon" href={icon} type="image/x-icon" />}
            <style dangerouslySetInnerHTML={{ __html: css }} />
        </>
    );
};
